import React from "react";
import Bee from "../../assets/abelha.png";
import "./LoadingIndicator.css";

const LoadingIndicator = () => (
  <div className="loading-indicator">
    <div className="loader-container">
      <div className="circular-loader">
        <div className="bee-wrapper">
          <img src={Bee} alt="Extraindo o mel..." className="bee-circular" />
        </div>
      </div>
      <p className="loading-text">Extraindo o mel...</p>
    </div>
  </div>
);

export default LoadingIndicator;
